module.exports = __webpack_public_path__ + "static/howitworks-cc199db2a88781421e769a7747dd21c4.svg";